/// <reference path="../_all.ts" />

module editor {
  'use strict';

  EditorDirective.$inject = ['editorService', '$mdDialog', '$templateCache', '$compile'];
  export function EditorDirective(
    editorService : IEditorService
    , $mdDialog : ng.material.IDialogService
    , $templateCache : ng.ITemplateCacheService
    , $compile : ng.ICompileService): ng.IDirective {

    return {
      restrict: 'A',
      scope: {
        'editorConfig' : '@'
        , 'editorConfigVar' : '='
      },
      link: function (scope: IEditorDirectiveScope, element: JQuery, attr: IEditorDirectiveAttributes) {
        if (scope.editorConfigVar) {
          scope.config = scope.editorConfigVar;          
        } else {
          if (scope.editorConfig) {
            scope.config = JSON.parse(scope.editorConfig);
          } else {
            scope.config = new EditorFilter(pglob.RouteData.RouteEntry.RouteParameterStack, false, true, null, null, null, null, null, null, null, false);      
          }
        }

        attr.$observe('editorConfig', function(value : string) { 
          if (scope.editorConfig) {
            scope.config = JSON.parse(scope.editorConfig);
          } else {
            scope.config = new EditorFilter(pglob.RouteData.RouteEntry.RouteParameterStack, false, true, null, null, null, null, null, null, null, false);      
          }
        })

        var setDisplay = (button : JQuery, display : string) => {
          return function(event:JQueryEventObject) {
            button.css("display", display);
          };
        };

        scope.openEditor = (event : MouseEvent) => {
          if (event) event.preventDefault();
          
          var rpv: IRouteParameter[] = pglob.RouteData.RouteEntry.RouteParameterStack;

          if (scope.config.UseRouteParam) {

            if (rpv.length == 1) {
              scope.config.Filter1 = rpv[0].Id;
            }

            if (rpv.length == 2) {
              scope.config.Filter1 = rpv[1].Id;
              scope.config.Filter2 = rpv[0].Id;
            }

            if (rpv.length == 3) {
              scope.config.Filter1 = rpv[2].Id;
              scope.config.Filter2 = rpv[1].Id;
              scope.config.Filter3 = rpv[0].Id;
            }
          }

          scope.config.FilterString1 = scope.config.FilterString1 || pglob.RouteData.PageId;
          scope.config.rpv = pglob.RouteData.RouteEntry.RouteParameterStack;
          
          var editorTemplate = <string> $templateCache.get('editormodaltemplate.html') || editor.EditorModalTemplate();

          $mdDialog.show(<ng.material.IDialogOptions>{
            controller: 'editorCtrl',
            template: editorTemplate,
            parent: angular.element(document.body),
            bindToController: true,
            targetEvent: null,
            clickOutsideToClose:false,
            //fullscreen: true, // Only for -xs, -sm breakpoints.
            locals : {
              filter : scope.config
            },
          })
          .then((message : {filter : EditorFilter, data : string}) => { //close
            console.log('Modal closed at: ' + new Date());
            if (scope.config.Replace) {
              element.html(message.data);  
              wireEditButton();
            }
          }, (message : {filter : EditorFilter, data : string}) => { //cancel
            console.log('Modal canceled at: ' + new Date());
          });

        };

        var wireEditButton = () => {
          var editButton = $compile( '<md-button ng-click="openEditor($event)" title="{{config.FilterString2}}" class="btn md-primary edit animate-show" style="display: none;">Bearbeiten</md-button>' )( scope );
          element.append(editButton);
          element.css('position', 'relative');
          element.bind('mouseenter', setDisplay(editButton, "inherit"));
          element.bind('mouseleave', setDisplay(editButton, "none"));
        };

        wireEditButton();

      }
    }
  }
}